import Joi from 'joi-browser';
//import { language, apiUrl, wapiKey, request } from '../../controller-config';
import axios from 'axios';
import { WAPIAddress } from 'constants/config';
import * as wapiKeys from '../../../apiKeys';

const wapiKey = process.env.APP_ENV === 'development'? wapiKeys.dev_key : wapiKeys.prod_key;
export const schema = Joi.object().keys({
  phone: Joi.string().required(),
  code: Joi.string().required(),
});

export default function changePhone(opts) {
  let validateResult = Joi.validate(opts, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject) => {
      reject(validateResult);
    });
  }

  return new Promise((resolve, reject) => {
    // request({
    //   url: `${apiUrl}/wapi/v1/change_mobile/`,
    //   method: 'PUT',
    //   data: opts,
    //   header: {
    //     'content-type': 'application/json',
    //     "WAPI-KEY": wapiKey,
    //     'authorization': 'JWT ' + token
    //   },
    //   success(res) {
    //     resolve(res.data)
    //   }
    // })

    axios.put(WAPIAddress, {'uri': '/change_mobile/',
      'method': 'PUT',
      'data': JSON.stringify(opts),
      'token': localStorage.getItem('token'),
      'wapiKey': wapiKey,
    })
      .then((res) => {
        resolve(res.data);
      })
        .catch((err) => {
          reject(err);
        })
  })
}


// WEBPACK FOOTER //
// ./src/controllers/controllers/user/changePhone.js